<template>
  <div class="overview-container flex">
    <div style="margin: 10px;" class="flex1">
      <div class="welcome-title">
        <span style="color: #FFFFFF; font-size: 0.8rem;">Doneist</span>
        <span class="welcome-subtitle"> 新应用时代开拓者</span>
      </div>
      <el-row :gutter="20" class="cards-row">
        <el-col :span="6" v-for="(item, index) in overviewItems" :key="item.title">
          <div class="overview-card" :style="{ background: item.gradient }">
            <div class="card-content">
              <div class="card-left">
                <div class="card-title">{{ item.title }}</div>
                <div class="card-value">{{ item.value }}</div>
              </div>
              <div class="card-icon">
                <i :class="item.icon"></i>
              </div>
            </div>
            <div class="card-decorator"></div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="copyright">
      © 2026 Doneist Project. All rights reserved.   |  备案号：蜀ICP备19030913号-2
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
  data() {
    return {
      overviewItems: [
        { 
          title: '用户', 
          value: '0', 
          icon: 'el-icon-user',
          gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          key: 'userCount'
        },
        { 
          title: '数据源', 
          value: '0', 
          icon: 'el-icon-s-data',
          gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          key: 'dataSourceCount'
        },
        { 
          title: '项目', 
          value: '0', 
          icon: 'el-icon-folder-opened',
          gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
          key: 'projectCount'
        },
        { 
          title: '模板', 
          value: '0', 
          icon: 'el-icon-document',
          gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
          key: 'templateCount'
        },
        { 
          title: '定时任务', 
          value: '0', 
          icon: 'el-icon-time',
          gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
          key: 'scheduleTaskCount'
        },
        { 
          title: '在线人数', 
          value: '0', 
          icon: 'el-icon-user-solid',
          gradient: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
          key: 'onlineUserCount'
        },
        { 
          title: '日活人数', 
          value: '0', 
          icon: 'el-icon-s-custom',
          gradient: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
          key: 'dailyActiveUserCount'
        },
        { 
          title: '日请求次数', 
          value: '0', 
          icon: 'el-icon-s-marketing',
          gradient: 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
          key: 'dailyRequestCount'
        },
      ],
    };
  },
  computed: {
    ...mapState({
      statistics: state => state.system.overview.statistics
    })
  },
  watch: {
    statistics: {
      handler(newVal) {
        this.updateOverviewItems(newVal);
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getStatistics();
  },
  methods: {
    ...mapActions({
      getStatistics: 'system/overview/getStatistics'
    }),
    updateOverviewItems(statistics) {
      this.overviewItems.forEach(item => {
        if (statistics[item.key] !== undefined) {
          item.value = this.formatNumber(statistics[item.key]);
        }
      });
    },
    formatNumber(num) {
      if (num === undefined || num === null) return '0';
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
};
</script>

<style scoped>
.overview-container {
  padding: 30px;
  height: calc(100% - 1.3rem);
  background-image: url('~@/assets/login_background.jpg');
  background-size: cover;
  color: #FFFFFF;
  background-position: center;
  overflow: hidden;
  border-style: solid;
  border-width: 1px;
  border-color: #FFFFFF;
  position: relative;
}

.welcome-title {
  font-size: 0.6rem;
  margin-bottom: 35px;
  font-weight: bolder;
}

.welcome-subtitle {
  color: rgba(255, 255, 255, 0.9);
}

.cards-row {
  margin-bottom: 20px;
}

.overview-card {
  margin-bottom: 25px;
  border-radius: 16px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  color: white;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.overview-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.25);
}

.card-content {
  padding: 24px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}

.card-left {
  flex: 1;
}

.card-title {
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 8px;
  font-weight: 500;
}

.card-value {
  font-size: 32px;
  font-weight: bold;
  line-height: 1.2;
}

.card-icon {
  font-size: 56px;
  opacity: 0.3;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-icon i {
  transition: transform 0.4s ease;
}

.overview-card:hover .card-icon i {
  transform: scale(1.2) rotate(10deg);
  opacity: 0.5;
}

.card-decorator {
  position: absolute;
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  top: -30px;
  right: -30px;
  z-index: 1;
  transition: all 0.4s ease;
}

.overview-card:hover .card-decorator {
  width: 150px;
  height: 150px;
  top: -50px;
  right: -50px;
}

.copyright {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  height: auto;
  text-align: center;
  margin-right: 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  letter-spacing: 0.5px;
}
</style>
